var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 95.49 127.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3bc1d3;}.cls-2{fill:#359ebb;}.cls-3{fill:#f18122;}.cls-4{fill:#f6911e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.33,74.93a60.75,60.75,0,0,0-17.52-4.22L47.72,127.23H91a3.17,3.17,0,0,0,3.17-3c0-.85,1.29-20.71,1.29-25.84,0-11-5.44-18.86-16.16-23.49",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.89,70C16.11,70,0,79.58,0,98.42c0,5.12,1.14,25,1.18,25.82a3.18,3.18,0,0,0,3.17,3H47.72L61.81,70.71A128.56,128.56,0,0,0,47.89,70",
    className: "cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.75,0C30.1,0,25.91,13.77,25.5,25.35c0,.34,0,12.67,0,12.79,0,11.41,3.49,18,8.29,21.63L48.68,0l-.93,0",
    className: "cls-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70,25.31C69.55,14,65.48.51,48.68,0L33.78,59.77c4.14,3.14,9.27,4.1,14,4.1C57.9,63.87,70,59.41,70,38.14c0-8.28,0-12.59,0-12.83",
    className: "cls-4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon);
export default __webpack_public_path__ + "static/media/create-icon.d8d45bbbad213256cb77117960b27c3f.svg";
export { ForwardRef as ReactComponent };